import { Injectable } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';

@Injectable({
    providedIn: 'root',
})
export class PaginationService {
    getTotalPages(paginator: MatPaginator): number {
        return paginator && paginator.length ? Math.ceil(paginator.length / paginator.pageSize) : 1;
    }

    goToFirstPage(paginator: MatPaginator): void {
        paginator.firstPage();
    }

    goToPreviousPage(paginator: MatPaginator): void {
        if (paginator.pageIndex > 0) {
            paginator.previousPage();
        }
    }

    goToNextPage(paginator: MatPaginator): void {
        if (paginator.pageIndex + 1 < this.getTotalPages(paginator)) {
            paginator.nextPage();
        }
    }

    goToLastPage(paginator: MatPaginator): void {
        const lastPageIndex = this.getTotalPages(paginator) - 1;
        paginator.pageIndex = lastPageIndex;
        paginator._changePageSize(paginator.pageSize); // Force update
    }
}
